import Link from "next/link";
import { cn } from "@/lib/utils";

type Props = {
  href?: string | null;
  className?: string;
  imageClassName?: string;
  showWordmark?: boolean;
  /** Always show the wordmark (default hides it on very narrow screens). */
  wordmarkAlways?: boolean;
  wordmarkClassName?: string;
};

export function BrandLogo({
  href = "/",
  className = "",
  imageClassName = "h-9 w-9",
  showWordmark = true,
  wordmarkAlways = false,
  wordmarkClassName = "text-xl",
}: Props) {
  const inner = (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/logo.png" alt="" className={cn("shrink-0 object-contain", imageClassName)} />
      {showWordmark && (
        <span
          className={cn(
            "font-display font-bold tracking-tight text-ink",
            wordmarkAlways ? "inline" : "hidden min-[400px]:inline",
            wordmarkClassName,
          )}
        >
          Chati<span className="text-brand">Safe</span>
        </span>
      )}
    </span>
  );
  if (href) {
    return (
      <Link href={href} className="shrink-0 rounded-lg" aria-label="ChatiSafe">
        {inner}
      </Link>
    );
  }
  return inner;
}
